import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { CartAttributes, CartDetailAttributes } from 'src/app/cart-detail/cart';
import { CartService } from 'src/app/cart-detail/cart.service';
import { Config } from 'src/app/services/env.config';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from 'src/app/shared/success-dialog/success-dialog.component';
import { WaitingDialogComponent } from 'src/app/shared/waiting-dialog/waiting-dialog.component';
import { ProductCatalogueAttributes } from '../product';
import { ProductService } from '../product-list.service';

@Component({
  selector: 'app-product-detail-popup',
  templateUrl: './product-detail-popup.component.html',
  styleUrls: ['./product-detail-popup.component.scss']
})
export class ProductDetailPopupComponent implements OnInit {

  action = new Subject();
  message: string;
  data: any;
  imgSrc: any;

  closeResult: string;
  productDetail: ProductCatalogueAttributes = new ProductCatalogueAttributes();
  BaseUrlToDownloadImage = Config.BaseEndpoint + 'itemImages/downloadItemImageByFileNameAsResourceForDealer/';
  productQuantity: number = 0;
  totalPrice: number;
  totalDiscount: number;
  newProductForCart: CartAttributes = new CartAttributes();
  newProductDetailForCart: CartDetailAttributes = new CartDetailAttributes();
  loggedInUser: any;
  imagesArray: any[] = [];
  tempProductDetail: any;
  confirmationModalRef: MDBModalRef;
  waitingModalRef: MDBModalRef;
  cartDetails: CartAttributes;
  newProductFlag: boolean;
  existingProductInCart: CartDetailAttributes = new CartDetailAttributes();
  updatedQtyForProduct: CartDetailAttributes = new CartDetailAttributes();
  imageSliderCounter: number = 0;
  imageIntervalRef: any;
  confirmModalRef: MDBModalRef;

  constructor(private productService: ProductService, private cartService: CartService, private modalService: MDBModalService
    , private route: ActivatedRoute,private _sanitizer: DomSanitizer, private router: Router) {
    this.loggedInUser = JSON.parse(sessionStorage.getItem('user'))
    this.tempProductDetail = this.productService.productDetail;
  }

  gifImagesList: any[];
  ngOnInit() {
    this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
      data: {
        message: 'Fetching Product Details'
      }
    })
    if (this.tempProductDetail == undefined) {
      this.getProductDetailByItemCode(this.message)
    }
    else {
      if (this.tempProductDetail.itemCode == this.message) {
        this.productDetail = this.tempProductDetail;
        this.productDetail.netvalue = parseFloat(this.productDetail.netvalue)
        this.productDetail.discountedPrice = (this.productDetail.itemPrice - this.productDetail.netvalue).toFixed(2);
        if (this.productDetail.itemImages.length != 0) {
          var temp = this.productDetail.itemImages.filter(x => x.fileExtension == '.gif')
          if(temp.length > 0) {
            this.productDetail.mainImageUrl = this.BaseUrlToDownloadImage + temp[0].fileName + temp[0].fileExtension + '/';

          }
          else {
            this.productDetail.mainImageUrl = this.BaseUrlToDownloadImage + this.productDetail.itemImages[0].fileName + this.productDetail.itemImages[0].fileExtension + '/';

          }
        }
        else {
          this.productDetail.mainImageUrl = 'assets/img/NoImage.png';
        }
        this.imagesArray = this.productDetail.itemImages;
        this.getCartDetails();
        // this.setImageInterval()
      }

      else {
        this.getProductDetailByItemCode(this.message);
      }
    }
  }

  getProductDetailByItemCode(itemCode) {
    this.productService.getProductDetailByItemCode(itemCode).then((data) => {
      console.log(data)
      this.productDetail = data[0];
      this.productDetail.netvalue = parseFloat(this.productDetail.netvalue)
      this.productDetail.discountedPrice = (this.productDetail.Price - this.productDetail.netvalue).toFixed(2);
      if (this.productDetail.ImagePath) {
          if (this.productDetail.ImagePath.length != 0) {
            this.productDetail.ImagePath =  Config.ImageEndpoint + this.productDetail.ImagePath;
          }
    }
      else {
        console.log("yes")
        this.productDetail.ImagePath = 'assets/img/NoImage.png';
      }
      this.imagesArray = this.productDetail.itemImages;
      this.getCartDetails();
      // this.setImageInterval()
    });
  }

  getCartDetails() {
    //debugger
    this.cartService.getCartDetailsForUser().then((data: any) => {
      this.cartDetails = data;
      let cartdata : any[] = [];
      // debugger;
      if (this.cartDetails != null) {

        for(let i = 0; i< data.length ; i++ ) {
          cartdata.push(this.cartDetails[i]);
        }
        if (data.length != 0) {
          this.cartService.cartProductCount = data.length;
          var itemCheck = cartdata.filter(x=> x.ProductCode == this.productDetail.ProductCode)
          if(itemCheck.length > 0) {
            this.existingProductInCart = itemCheck[0];
            this.productQuantity = itemCheck[0].Qty;
            this.qtyInput = this.productQuantity;
            this.qtyexist = this.productQuantity;
            this.newProductFlag = false;
            setTimeout(x => {
              this.waitingModalRef.hide();
            }, 500)
          }
          else {
            this.newProductFlag = true;
          }
          // for (let element of this.cartDetails.cartDetailVo) {
          //
          //   if (element.itemId != this.productDetail.itemId) {
          //     this.newProductFlag = true;
          //     break;
          //   }
          //   else {
          //     this.existingProductInCart = element;
          //     this.productQuantity = element.qty;
          //     this.newProductFlag = false;
          //     setTimeout(x => {
          //       this.waitingModalRef.hide();
          //     }, 500)
          //   }
          // }
        }
        else {
          this.newProductFlag = true;
        }
      }
      else {
        this.newProductFlag = true;
      }
      setTimeout(x => {
        this.waitingModalRef.hide();
      }, 300)
    }, error => {
      setTimeout(x => {
        this.waitingModalRef.hide();
      }, 500)
    });
  }

  addNewProductToCart(typeOfButton) {
    this.cartService.saveNewProductToCart(this.newProductForCart.cartDetailVo).then((data) => {
      if(data[0].ErrorName == "Saved") {
        if (typeOfButton == 'cart') {
          this.getCartDetails();
        }
        else {
          this.action.next('CartDetails');
          // this.router.navigate(['/cart/detail'])
        }
      } else  if(data[0].ErrorName == "error"){
        alert("Something went wrong");
      }
      else {
        alert("Product Code is not Present");
      }
      
    });
  }

  
  //To Check whether product is already available in cart
  checkProductStatusInCart(typeOfButton) {
    let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
    let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
    let User = JSON.parse(sessionStorage.getItem('userDetails'));
    // if(this.productQuantity > this.productDetail.Stock && this.productQuantity > 0){
    //   this.confirmModalRef = this.modalService.show(ErrorDialogComponent, {
    //     data: {
    //       message: "The Product "+this.productDetail.ProductCode+"'s Qty Cannot be greater than available stock",
    //       data: []
    //      }
    //   });
    //  this.confirmModalRef.content.action.subscribe(result => {
    //    if (result == 'OK') {
    //      this.confirmModalRef.hide();
    //    }
    //  })
    // }
    
       if(this.productDetail.SKUType !=='Active'){
      this.confirmModalRef = this.modalService.show(ErrorDialogComponent, {
        data: {
          message: "The Product "+this.productDetail.ProductCode+"'s Qty Cannot be greater than available stock",
          data: []
         }
      });
     this.confirmModalRef.content.action.subscribe(result => {
       if (result == 'OK') {
         this.confirmModalRef.hide();
       }
     }) 
    }
    if(RSSO){
      if(Deal && (Deal != User.UserName)) {
        if(this.productDetail.SKUType ==='Active'){

    if (this.productQuantity > 0) {
      this.newProductForCart = new CartAttributes();
      this.newProductDetailForCart = new CartDetailAttributes();
      this.newProductForCart.cartDetailVo = [];
      this.newProductDetailForCart.ProductCode = this.productDetail.ProductCode;
      this.newProductDetailForCart.Qty = this.productQuantity;
      this.newProductDetailForCart.UserName = this.loggedInUser.UserName;
      this.newProductDetailForCart.DealUserName = this.loggedInUser.DealUserName;
      // if('cart') {
        this.newProductDetailForCart.SNo = 0;
      // } else {
      //   this.newProductDetailForCart.SNo = 1;
      // }
      
      this.newProductForCart.cartDetailVo.push(this.newProductDetailForCart);
      // if (this.newProductFlag) {
        this.addNewProductToCart(typeOfButton);
      
      // }
      // else {
      //   this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
      //     data: {
      //       message: 'Adding Product To Cart'
      //     }
      //   })
      //   this.updateQtyForExistingProduct(this.existingProductInCart.cartDetailDomainId, this.existingProductInCart.Qty, typeOfButton);

      // }
      let pagename;
      if(this.productDetail.Category == 'WATCHES') {
         pagename = 'Watches';
      } else if (this.productDetail.Category == 'FRAGRANCES') {
        pagename = 'Fragances';
      } else {
        pagename = 'Accessories';
      }
      this.cartService.getCartCount().then((response) => {
        setTimeout(x => {
          this.action.next('OK');
        }, 300)
      });
      // this.router.navigate(['/product/list'] , { queryParams: { page: pagename } });
    }
  }
    else {
      this.confirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
        data: {
          message: 'Please Select Atleast 1 Quantiy or Click "Yes" to go to cart'
        }
      });
      this.confirmationModalRef.content.action.subscribe((result: any) => {
        if (result == 'yes') {
          this.confirmationModalRef.hide();
          this.action.next('CartDetails');
         
        }
        else {
          this.confirmationModalRef.hide();
        }
      });
    }
  } else {
    let data = [];
    this.confirmationModalRef = this.modalService.show(SuccessDialogComponent, {
      data: {
        message: 'Please Select dealer' ,
        data: data
      }
    });
    this.confirmationModalRef.content.action.subscribe(result => {
      if (result == 'OK') {
        this.confirmationModalRef.hide();
      }
    })
  }
}
  else if(User.DesigId == 3 || User.DesigId == 2 ) {
    if (this.productQuantity > 0) {
      this.newProductForCart = new CartAttributes();
      this.newProductDetailForCart = new CartDetailAttributes();
      this.newProductForCart.cartDetailVo = [];
      this.newProductDetailForCart.ProductCode = this.productDetail.ProductCode;
      this.newProductDetailForCart.Qty = this.productQuantity;
      this.newProductDetailForCart.UserName = this.loggedInUser.UserName;
      this.newProductDetailForCart.DealUserName = this.loggedInUser.DealUserName;
      // if('cart') {
        this.newProductDetailForCart.SNo = 0;
      // } else {
      //   this.newProductDetailForCart.SNo = 1;
      // }
      
      this.newProductForCart.cartDetailVo.push(this.newProductDetailForCart);
      // if (this.newProductFlag) {
        this.addNewProductToCart(typeOfButton);
      
      // }
      // else {
      //   this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
      //     data: {
      //       message: 'Adding Product To Cart'
      //     }
      //   })
      //   this.updateQtyForExistingProduct(this.existingProductInCart.cartDetailDomainId, this.existingProductInCart.Qty, typeOfButton);
      // }
      let pagename;
      if(this.productDetail.Category == 'WATCHES') {
         pagename = 'Watches';
      } else if (this.productDetail.Category == 'FRAGRANCES') {
        pagename = 'Fragances';
      } else {
        pagename = 'Accessories';
      }
      this.cartService.getCartCount().then((response) => {
        setTimeout(x => {
          this.action.next('OK');
        }, 300)
      });
      // this.router.navigate(['/product/list'] , { queryParams: { page: pagename } });
    }
    else {
      this.confirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
        data: {
          message: 'Please Select Atleast 1 Quantiy or Click "Yes" to go to cart'
        }
      });
      this.confirmationModalRef.content.action.subscribe((result: any) => {
        if (result == 'yes') {
          this.confirmationModalRef.hide();
          this.action.next('CartDetails')
          // this.router.navigate(['/cart/detail'])
        }
        else {
          this.confirmationModalRef.hide();
        }
      });
    }
  } else {
    let data = [];
    this.cartmodalRef = this.modalService.show(SuccessDialogComponent, {
      data: {
        message: 'You are not authorized to use this feature',
        data: data
      }
    });
    this.cartmodalRef.content.action.subscribe(result => {
      if (result == 'OK') {
        this.cartmodalRef.hide();
      }
    })
  }
}
checkProductStatusInCartForAddToCart(typeOfButton) {
  let RSSO = JSON.parse(sessionStorage.getItem('RSSO'));
  let Deal = JSON.parse(sessionStorage.getItem('DealUserName'));
  let User = JSON.parse(sessionStorage.getItem('userDetails'));
  
  if (this.productDetail.SKUType !== 'Active' && this.productQuantity > this.productDetail.Stock) {
    this.confirmModalRef = this.modalService.show(ErrorDialogComponent, {
      data: {
        message: "The Product " + this.productDetail.ProductCode + "'s Qty Cannot be greater than available stock",
        data: []
      }
    });
    this.confirmModalRef.content.action.subscribe(result => {
      if (result == 'OK') {
        this.confirmModalRef.hide();
      }
    });
  }
  else if (RSSO) {
    if (Deal && (Deal != User.UserName)) {
      if (this.productQuantity > 0) {
        // Add product to cart
        this.newProductForCart = new CartAttributes();
        this.newProductDetailForCart = new CartDetailAttributes();
        this.newProductForCart.cartDetailVo = [];
        this.newProductDetailForCart.ProductCode = this.productDetail.ProductCode;
        this.newProductDetailForCart.Qty = this.productQuantity;
        this.newProductDetailForCart.UserName = this.loggedInUser.UserName;
        this.newProductDetailForCart.DealUserName = this.loggedInUser.DealUserName;
        this.newProductDetailForCart.SNo = 0;

        this.newProductForCart.cartDetailVo.push(this.newProductDetailForCart);

        this.addNewProductToCart(typeOfButton);

        let pagename;
        if (this.productDetail.Category == 'WATCHES') {
          pagename = 'Watches';
        } else if (this.productDetail.Category == 'FRAGRANCES') {
          pagename = 'Fragances';
        } else {
          pagename = 'Accessories';
        }

        this.cartService.getCartCount().then((response) => {
          setTimeout(x => {
            this.action.next('OK');
          }, 300);
        });
      }
      else {
        this.confirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
          data: {
            message: 'Please Select Atleast 1 Quantity or Click "Yes" to go to cart'
          }
        });
        this.confirmationModalRef.content.action.subscribe((result: any) => {
          if (result == 'yes') {
            this.confirmationModalRef.hide();
            this.action.next('CartDetails');
          }
          else {
            this.confirmationModalRef.hide();
          }
        });
      }
    } else {
      let data = [];
      this.confirmationModalRef = this.modalService.show(SuccessDialogComponent, {
        data: {
          message: 'Please Select dealer',
          data: data
        }
      });
      this.confirmationModalRef.content.action.subscribe(result => {
        if (result == 'OK') {
          this.confirmationModalRef.hide();
        }
      });
    }
  }
  else if (User.DesigId == 3 || User.DesigId == 2) {
    if (this.productQuantity > 0) {
      // Add product to cart
      this.newProductForCart = new CartAttributes();
      this.newProductDetailForCart = new CartDetailAttributes();
      this.newProductForCart.cartDetailVo = [];
      this.newProductDetailForCart.ProductCode = this.productDetail.ProductCode;
      this.newProductDetailForCart.Qty = this.productQuantity;
      this.newProductDetailForCart.UserName = this.loggedInUser.UserName;
      this.newProductDetailForCart.DealUserName = this.loggedInUser.DealUserName;
      this.newProductDetailForCart.SNo = 0;

      this.newProductForCart.cartDetailVo.push(this.newProductDetailForCart);

      this.addNewProductToCart(typeOfButton);

      let pagename;
      if (this.productDetail.Category == 'WATCHES') {
        pagename = 'Watches';
      } else if (this.productDetail.Category == 'FRAGRANCES') {
        pagename = 'Fragances';
      } else {
        pagename = 'Accessories';
      }

      this.cartService.getCartCount().then((response) => {
        setTimeout(x => {
          this.action.next('OK');
        }, 300);
      });
    }
    else {
      this.confirmationModalRef = this.modalService.show(ConfirmDialogComponent, {
        data: {
          message: 'Please Select Atleast 1 Quantity or Click "Yes" to go to cart'
        }
      });
      this.confirmationModalRef.content.action.subscribe((result: any) => {
        if (result == 'yes') {
          this.confirmationModalRef.hide();
          this.action.next('CartDetails');
        }
        else {
          this.confirmationModalRef.hide();
        }
      });
    }
  } else {
    let data = [];
    this.cartmodalRef = this.modalService.show(SuccessDialogComponent, {
      data: {
        message: 'You are not authorized to use this feature',
        data: data
      }
    });
    this.cartmodalRef.content.action.subscribe(result => {
      if (result == 'OK') {
        this.cartmodalRef.hide();
      }
    });
  }
}



cartmodalRef:MDBModalRef;
  updateQtyForExistingProduct(cartDetailDomainId, updatedQty, typeOfButton) {
    this.updatedQtyForProduct = new CartDetailAttributes();
    this.updatedQtyForProduct.cartDetailDomainId = cartDetailDomainId;
    this.updatedQtyForProduct.Qty = this.productQuantity;
    this.cartService.updateQuantityForExistingProduct(this.updatedQtyForProduct).then((data: any) => {
      setTimeout(x => {
        this.waitingModalRef.hide();
        if (typeOfButton == 'cart') {
        }
        else {
          this.action.next('CartDetails')
          // this.router.navigate(['/cart/detail'])
        }
      }, 300)

    });
  }
  checkPro(val) {
    console.log(this.qtyInput)
    this.productQuantity = this.qtyInput
  //  if(this.qtyInput > this.productDetail.Stock){
  //    alert("Quantity Cannot be greater than available stock.")
  //  }
 

  }
  qtyexist: number = 0;
  qtyInput: number = 0;
  checkQuantity(type) {
    if (type == 'add') {
      console.log(this.productDetail)
     if(this.productDetail.SKUType =='Active'||this.productQuantity < this.productDetail.Stock){
        this.productQuantity++;
    
      }else{
        alert("Quantity Cannot be greater than available stock.")
      }
    }
    else {
      if (this.productQuantity > 0) {
        this.productQuantity--;
      }
    }

  }

  toggleAccordian(event) {
    var element = event.target;
    element.classList.toggle('active1');
    var panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  imgClick(image: any) {
    /*this.imgSrc = image.src;
    changeImage.src = this.imgSrc;*/
    this.productDetail.mainImageUrl = this.BaseUrlToDownloadImage + image;
    clearInterval(this.imageIntervalRef);
  }

  setImageInterval() {
    if (this.imagesArray.length > 1) {
      this.imageIntervalRef = setInterval(x => {
        if (this.imageSliderCounter < this.imagesArray.length - 1) {
          this.imageSliderCounter++;
        }
        else {
          this.imageSliderCounter = 0;
        }
        this.productDetail.mainImageUrl = this.BaseUrlToDownloadImage + this.imagesArray[this.imageSliderCounter].fileName + this.imagesArray[this.imageSliderCounter].fileExtension + '/';
      }, 4000)
    }
  }

  ngOnDestroy() {
    clearInterval(this.imageIntervalRef)
  }
  close() {
    this.action.next('OK');
  }

}





//product-detail-popup   page ts